export default __webpack_public_path__ + "static/media/breaker4.1c8b9a72.png";